"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentPager = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/link/semantics/pager");
const sitemap_1 = require("@/sitemap");
const utils_1 = require("@/utils");
/** 문서 페이지 끝에서 사이트맵 순서의 이전·다음 문서로 이동한다. */
let ComponentPager = class ComponentPager extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.docs = (0, sitemap_1.findAdjacentDocs)((0, utils_1.getCurrentPageId)());
    }
    render() {
        const { previous, next } = this.docs;
        return (0, lit_1.html) `
      <mm-pager
        aria-label="문서 이동"
        .previous=${previous && {
            href: `${previous.id}.html`,
            heading: previous.name,
            description: '이전 문서',
        }}
        .next=${next && { href: `${next.id}.html`, heading: next.name, description: '다음 문서' }}
      ></mm-pager>
    `;
    }
};
ComponentPager.styles = (0, lit_1.css) `
    :host {
      display: block;
    }
  `;
ComponentPager = __decorate([
    (0, decorators_js_1.customElement)('mm-component-pager')
], ComponentPager);
exports.ComponentPager = ComponentPager;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tcG9uZW50LXBhZ2VyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiY29tcG9uZW50LXBhZ2VyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUEyQztBQUMzQyxxREFBaUQ7QUFFakQsb0RBQWlEO0FBQ2pELHVDQUE0QztBQUM1QyxtQ0FBMEM7QUFFMUMsMENBQTBDO0FBRW5DLElBQU0sY0FBYyxHQUFwQixNQUFNLGNBQWUsU0FBUSxnQkFBVTtJQUF2Qzs7UUFNRyxTQUFJLEdBQUcsSUFBQSwwQkFBZ0IsRUFBQyxJQUFBLHdCQUFnQixHQUFFLENBQUMsQ0FBQTtJQWlCckQsQ0FBQztJQWZDLE1BQU07UUFDSixNQUFNLEVBQUUsUUFBUSxFQUFFLElBQUksRUFBRSxHQUFHLElBQUksQ0FBQyxJQUFJLENBQUE7UUFFcEMsT0FBTyxJQUFBLFVBQUksRUFBQTs7O29CQUdLLFFBQVEsSUFBSTtZQUN0QixJQUFJLEVBQUUsR0FBRyxRQUFRLENBQUMsRUFBRSxPQUFPO1lBQzNCLE9BQU8sRUFBRSxRQUFRLENBQUMsSUFBSTtZQUN0QixXQUFXLEVBQUUsT0FBTztTQUNyQjtnQkFDTyxJQUFJLElBQUksRUFBRSxJQUFJLEVBQUUsR0FBRyxJQUFJLENBQUMsRUFBRSxPQUFPLEVBQUUsT0FBTyxFQUFFLElBQUksQ0FBQyxJQUFJLEVBQUUsV0FBVyxFQUFFLE9BQU8sRUFBRTs7S0FFeEYsQ0FBQTtJQUNILENBQUM7O0FBckJNLHFCQUFNLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7R0FJbEIsQ0FBQTtBQUxVLGNBQWM7SUFEMUIsSUFBQSw2QkFBYSxFQUFDLG9CQUFvQixDQUFDO0dBQ3ZCLGNBQWMsQ0F1QjFCO0FBdkJZLHdDQUFjIn0=